import {ItemListItemClass} from "./ItemListItemClass.ts";
import {getOptionalStringValue} from "../utils/common-utils.ts";
import {Language} from "../language/Language.ts";

export class ItemListClass {
    private constructor(
        readonly items: ItemListItemClass[],
        readonly viewmode: string,
        readonly paginated: boolean,
        readonly seeallbtn: boolean,
        readonly pageSize: number,
        readonly title?: string,
        readonly seeAllUrl?: string,
        // Carousel auto-advance interval, in seconds. Only the home tile carousel
        // (h_carrousel_with_f_number) sets it; the server now sends it on the list
        // (the home page no longer computes a data-fade attribute). Undefined ⇒ HCarousel default.
        readonly fadeOutSeconds?: number
    ) {
    }

    static constructInstance = (itemList: any, lang: Language) => {

        const items = ItemListClass.getItems(itemList, lang)
        const viewmode = ItemListClass.getViewMode(itemList)
        const paginated = ItemListClass.getPaginated(itemList);
        const seeallbtn = ItemListClass.getSeeAll(itemList)
        const title = getOptionalStringValue(itemList, "title", lang)
        const pagesize = ItemListClass.getPageSize(itemList)
        const seeAllUrl = getOptionalStringValue(itemList, "seeAllUrl", lang)
        const fadeOutSeconds = ItemListClass.getFadeOutSeconds(itemList)
        return new ItemListClass(items, viewmode, paginated, seeallbtn, pagesize, title, seeAllUrl, fadeOutSeconds);
    }

    private static getFadeOutSeconds(obj: any): number | undefined {
        const val = obj["fadeOutSeconds"]
        if (val === undefined || val === null || val === "") return undefined
        const n = parseInt(val)
        return isNaN(n) ? undefined : n
    }

    private static getSeeAll(obj: any): boolean {
        let val = obj["seeallbtn"]
        if (val && val.length > 0) return JSON.parse(val);
        val = obj["see_all_b"]
        if (val && val.length > 0) return JSON.parse(val);
        return false
    }

    private static getPaginated(obj: any): boolean {
        let val = obj["paginated"]
        if (val && val.length > 0) return JSON.parse(val);
        val = obj["paginated_b"]
        if (val && val.length > 0) return JSON.parse(val);
        return false
    }

    private static getViewMode(obj: any): string {
        let val = obj["view_mode_s"]
        if (val) return val;
        val = obj["viewmode"]
        if (val) return val;
        throw Error("No view mode set")
    }

    private static getPageSize(obj: any): number {
        let val = obj["page_size_t"]
        if (val) return parseInt(val);
        val = obj["pageSize"]
        if (val) return parseInt(val);
        val = obj["pagesize"]
        if (val) return parseInt(val);
        return 10;
    }

    private static getItems(obj: any, lang: Language): ItemListItemClass[] {
        const items = new Array<ItemListItemClass>();
        // Normalize obj.item: Crafter's XML-to-JSON serializer only produces arrays for 2+ elements.
        // Fewer items produce undefined (0 items) or a plain object (1 item).
        let rawItems = obj.item;
        if (rawItems === undefined || rawItems === null) {
            rawItems = [];
        } else if (!Array.isArray(rawItems)) {
            rawItems = [rawItems];
        }
        rawItems.map((it: any) => {
            const ili = ItemListItemClass.constructInstance(it, lang)
            if (ili && ili.url) { // filter out items without a URL (e.g. in the active language)
                items.push(ili);
            }
        })
        return items.filter(it => {
            return it.category != "IGNORE"
        });
    }
}